module.exports = __webpack_public_path__ + "static/sushi@2x-1eb3f94b4b7369461f5c565b5015d6a7.png";